<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import router from "./router/index.js"
  import index from "./pages/index.vue";
  import playerQuestions from "./pages/playerQuestions.vue";
  import scoring from "./pages/scoring.vue";
  import playerRanking from "./pages/playerRanking.vue";
  import countdown from "./pages/countdown.vue";
  import totalScore_player from "./pages/totalScore_player.vue";
  import playerRankingSplit from "./pages/playerRankingSplit.vue";
  import {
    adminSocket
  } from '../src/router/websocket.js';
  export default {
    name: "app",
    data() {
      return {

      }
    },
    provide() {
      //提供
      return {};
    },
    beforeUpdate() {

    },
    methods: {},
    router,
    render: h => h(App),
    components: {
      index,
      playerQuestions,
      scoring,
      playerRanking,
      countdown,
      totalScore_player,
      playerRankingSplit
    },
  };

</script>

<style>
  body {
    padding: 0;
    margin: 0;
  }

  .WLJY_logo {
    position: fixed;
    z-index: 100;
    width: 13.125rem;
    left: 6.25rem;
    top: 3.35rem;
  }

  html {
    font-size: 16px;
  }

  @media screen and (max-width: 1800px) {
    html {
      font-size: 15px !important;
    }
  }

  @media screen and (max-width: 1680px) {
    html {
      font-size: 14px !important;
    }
  }

  @media screen and (max-width: 1560px) {
    html {
      font-size: 13px !important;
    }
  }

  @media screen and (max-width: 1440px) {
    html {
      font-size: 12px !important;
    }
  }

  @media screen and (max-width: 1320px) {
    html {
      font-size: 11px !important;
    }
  }

  @media screen and (max-width: 1290px) {
    html {
      font-size: 10.75px !important;
    }
  }

  @media screen and (max-width: 1260px) {
    html {
      font-size: 10.5px !important;
    }
  }

  @media screen and (max-width: 1230px) {
    html {
      font-size: 10.25px !important;
    }
  }

  @media screen and (max-width: 1200px) {
    html {
      font-size: 10px !important;
    }
  }

  @media screen and (max-width: 1080px) {
    html {
      font-size: 9px !important;
    }
  }

  @media screen and (max-width: 960px) {
    html {
      font-size: 8px !important;
    }
  }

  @media screen and (max-width: 840px) {
    html {
      font-size: 7px !important;
    }
  }

  @media screen and (max-width: 720px) {
    html {
      font-size: 6px !important;
    }
  }

  @media screen and (max-width: 600px) {
    html {
      font-size: 5px !important;
    }
  }

  @media screen and (max-width: 550px) {
    html {
      font-size: 4px !important;
    }
  }

  /* @media screen and (max-width: 480px) {
    html {
      font-size: 4px !important;
    }
  } */

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .bg {
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  @font-face {
    font-family: 'DIN Condensed-Bold';
    src: url('~@/assets/DINCondensedBold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'DIN';
    src: url('~@/assets/UItwo_DINBold.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Abhaya Libre SemiBold';
    src: url('~@/assets/UItwo_AlibabaPuHuiTiBold.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  .bigTitle {
    letter-spacing: 0.1875rem;
  }

  .numRed_animation {
    animation-iteration-count: infinite;
    transform-origin: center center;
    animation: myfirst 1s infinite;
    -webkit-animation: myfirst 1s infinite;
  }

  @keyframes myfirst {
    0% {
      transform: translate(0rem);
    }

    5% {
      transform: translate(0.3125rem);
    }

    10% {
      transform: translate(0rem);
    }

    15% {
      transform: translate(-0.3125rem);
    }

    20% {
      transform: translate(0rem);
    }

    25% {
      transform: translate(0.3125rem);
    }

    30% {
      transform: translate(0rem);
    }

    35% {
      transform: translate(-0.3125rem);
    }

    40% {
      transform: translate(0rem);
    }

    /* 45% {
      transform: translate(0.3125rem);
    }

    50% {
      transform: translate(0rem);
    }

    55% {
      transform: translate(-0.3125rem);
    }

    60% {
      transform: translate(0rem);
    }

    65% {
      transform: translate(0.3125rem);
    }

    70% {
      transform: translate(0rem);
    }

    75% {
      transform: translate(-0.3125rem);
    }

    80% {
      transform: translate(0rem);
    }

    85% {
      transform: translate(0.3125rem);
    }

    90% {
      transform: translate(0rem);
    }

    95% {
      transform: translate(-0.3125rem);
    }

    100% {
      transform: translate(0rem);
    } */
  }

</style>



// WEBPACK FOOTER //
// src/App.vue